'use client';

import isPropValid from '@emotion/is-prop-valid';
import { useServerInsertedHTML } from 'next/navigation';
import { useEffect, useState } from 'react';
import { ServerStyleSheet, StyleSheetManager } from 'styled-components';

export const StyledWrapper = ({ children }: Readonly<{ children: React.ReactNode }>) => {
  const [styledComponentsStyleSheet] = useState(() => new ServerStyleSheet());
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  useServerInsertedHTML(() => {
    const styles = styledComponentsStyleSheet.getStyleElement();
    styledComponentsStyleSheet.instance.clearTag();
    return styles;
  });

  const shouldForwardProp = (propName: string, target: any) => {
    return typeof target === 'string' ? isPropValid(propName) : true;
  };

  // The server renders nothing here, so the first client render must match it.
  if (!hydrated) {
    return null;
  }

  return (
    <StyleSheetManager
      enableVendorPrefixes
      sheet={styledComponentsStyleSheet.instance}
      shouldForwardProp={shouldForwardProp}
    >
      {children}
    </StyleSheetManager>
  );
};
